export default {"src":"/_next/static/media/messaging-center.98ef3060.svg","height":619,"width":682};